import * as emitter from 'eventemitter3';

// this smooths over differences between node and browser imports
export default emitter?.EventEmitter || emitter;
